// extracted by mini-css-extract-plugin
export default {"linkBack":"style--linkBack--f9c48a","downloadContainer":"style--downloadContainer--211cf2"};